var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCamera = function SvgCamera(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 15,
    "data-width-24": 22,
    viewBox: "0 0 14.8 12.3",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M12.908 2.446h-2l-.228-.917A1.23 1.23 0 0 0 9.486.6H5.252a1.23 1.23 0 0 0-1.193.93l-.228.916h-2A1.23 1.23 0 0 0 .6 3.677v6.77a1.23 1.23 0 0 0 1.23 1.23h11.077a1.23 1.23 0 0 0 1.23-1.23v-6.77a1.23 1.23 0 0 0-1.23-1.23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M7.37 9.523a2.77 2.77 0 1 0 0-5.538 2.77 2.77 0 0 0 0 5.538"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCamera);
export default ForwardRef;